export const getCurrentDateTime = () => {
  const currentDate = new Date().getTime() / 1000;
  return currentDate.toString();
};
